export default __webpack_public_path__ + "static/media/footerImage.2ee230cd.png";